import React, { Component } from 'react';
import { Modal, Header, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { FieldEnum } from '../../../common/FieldEnum';
import EditForm from './EditForm';

class EditModalContainer extends Component {
  state = {
    isValid: true,
  };

  componentWillReceiveProps(nextProp) {
    if (this.props.isEditValid !== nextProp.isEditValid) {
      this.setState({ isValid: nextProp.isEditValid });
    }
  }

  onSaveClick = () => this.form.submit();

  render() {
    const { modalData, isReadOnly, isSubmitting } = this.props;
    const isNew = this.props.modalData.Id === 0;

    return (
      <Modal
        open={this.props.showEditModal}
        onClose={this.props.onClose}
        size="large"
        closeIcon
        closeOnRootNodeClick={false}
      >
        <Header
          content={`${
            isNew ? 'Add New User' : 'Edit User ' + modalData.UserName
          }`}
          // content="Manage Students"
          icon={isNew ? 'plus' : 'signup'}
        />
        <Modal.Content className="p-t-0">
          <Modal.Description>
            <EditForm
              ref={instance => {
                this.form = instance;
              }}
              onSubmit={this.props.handleEditSubmit}
              availableRoles={this.props.roles}
              initialValues={{
                [FieldEnum.Id]: modalData.Id,
                [FieldEnum.Username]: modalData.UserName,
                [FieldEnum.FirstName]: modalData.FirstName,
                [FieldEnum.LastName]: modalData.LastName,
                [FieldEnum.RoleId]: modalData.RoleId,
                [FieldEnum.IsActive]: !modalData.IsActive,
                [FieldEnum.Password]: modalData.Password,
                [FieldEnum.Email]: modalData.Email,
              }}
              showPassword={modalData.Id === 0 ? true : false}
              setIsValid={isValid => {
                this.setState({ isValid });
              }}
              userSetup={this.props.userSetup}
              isNew={isNew}
              disableUserName={
                this.props.currentUserName === modalData.UserName
              }
            />
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="SAVE"
            inverted
            color="orange"
            size="big"
            disabled={!this.state.isValid || isSubmitting || isReadOnly}
            onClick={this.onSaveClick}
            loading={isSubmitting}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = ({ UserSetupState }) => {
  return {
    isSubmitting: UserSetupState.result.isSubmitting,
    isDone: UserSetupState.result.isDone,
    errors: UserSetupState.result.errors,
  };
};

export const EditModal = connect(
  mapStateToProps,
  null
)(EditModalContainer);



// WEBPACK FOOTER //
// ./src/pages/usersetup/components/EditModal.js